import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_SURVEY_SERVICE_BASE_URL;


export const getAllSurveys = async() => await axios.get(apiBaseUrl+'assessment/surveys/getAllSurveys');
export const getSurveyById = (surveyId: any) => axios.get(apiBaseUrl+'assessment/survey/'+surveyId);
export const getSurveyResponseBySurveyId=(surveyId: any) => axios.get(apiBaseUrl+'assessment/survey/responses/'+surveyId);
export const postSurvey = (reqBody: any) => axios.post(apiBaseUrl+'assessment/survey', reqBody);
export const postSurveyResponse = (reqBody: any) => axios.post(apiBaseUrl+'assessment/survey/response',reqBody);
export const patchSurvey = (surveyId: any) => axios.patch(apiBaseUrl+'assessment/survey/'+surveyId);
export const surveyOtp = (otp?: any) => axios.post(apiBaseUrl+'assessment/otp', otp);

